'use client'

import {NewsCard, NewsCardProps} from '@local/ui/components'

export interface NewsCardGridContentProps {
	cards: Array<NewsCardProps>
}

export const NewsCardGridContent = ({cards}: NewsCardGridContentProps) => {
	return (
		<div className='flex flex-col items-center  '>
			{!!cards.length && (
				<ul className='flex flex-wrap my-50 justify-center  gap-20  lg:justify-between lg:my-60'>
					{cards.map((card, index) => (
						<li key={index}>
							<NewsCard {...card} isLarge={index === 6} />
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
